export const isNumber = (n: unknown) => typeof n === 'number' && !isNaN(n);
